import { render, staticRenderFns } from "./function-score-feature-container.component.vue?vue&type=template&id=57f381c4&scoped=true"
import script from "./function-score-feature-container.component.vue?vue&type=script&lang=ts"
export * from "./function-score-feature-container.component.vue?vue&type=script&lang=ts"
import style0 from "./function-score-feature-container.component.vue?vue&type=style&index=0&id=57f381c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f381c4",
  null
  
)

export default component.exports